<template>
  <div>
    <grid-x col="1fr 1fr" row="1fr" gap="2em">
      <div class="col-1">
        <h3>Update PodCasts</h3>
        <div class="widget-buttons">
          <button v-on:click="updateCachePodcast()">Update Podcast Cache</button>
        </div>
        <div class="input-box down-caret">
          <select
            v-model="selectedPodcast"
            class="podcast-list-select"
            @change="selected()"
            @focus="changeColor()"
            ref="podcastSelector"
          >
            <option disabled value>Select a podcast</option>
            <option
              v-for="(item,key) in podcasts"
              :key="key"
              :value="item.title"
            >{{item.title}} -- {{item.count}}</option>
          </select>
        </div>
        <div v-for="(item,key) in podcasts" :key="key">
          <div v-if="selectedPodcast === item.title" class="draggable-items flex center-flex-y">
            <span>{{item.title}}</span>
            <span>- {{item.count}} Episodes</span>
            <div class="podcast-buttons">
              <button v-on:click="removePodcastItem(item)">Remove</button>
              <button v-on:click="editPodcastItem(item)">Edit</button>
            </div>
          </div>
        </div>
        <grid-x col="1fr 1fr" row="1fr" gap=".5em">
          <div v-if="editPodcastMode" class="podcast-edit">Podcast Slug
            <div class="input-box">
              <input v-model="editPodcast.key" type="text" placeholder="Podcast Slug">
            </div>Podcast Title
            <div class="input-box">
              <input v-model="editPodcast.obj.title" type="text" placeholder="Podcast Title">
            </div>Podcast RSS
            <div class="input-box">
              <input v-model="editPodcast.obj.rss" type="text" placeholder="Podcast RSS">
            </div>SEO Title
            <div class="input-box">
              <input v-model="editPodcast.obj.seoTitle" type="text" placeholder="SEO Title">
            </div>SEO Description
            <div class="input-box">
              <input
                v-model="editPodcast.obj.seoDescription"
                type="text"
                placeholder="SEO Description"
              >
            </div>Subscribe URL
            <div class="input-box">
              <input v-model="editPodcast.obj.subscribeUrl" type="text" placeholder="Subscribe URL">
            </div>
            <button style="margin-top:20px;float:left;" @click="executeEditPodcast">Save Edit</button>
          </div>
          <div v-if="editPodcastMode">
            <h3>Square Image</h3>
            <img
              :src="editPodcast.obj.overrideImage ? editPodcast.obj.overrideImage : editPodcast.obj.image"
              style="width:100px;height:100px;display:block"
            >
            <ic-firebase-upload
              path="images"
              max-files="1"
              :getFileName="getFileName"
              :storage="storage"
              @uploaded="onUploadedPodcastImage"
              @upload="onUpload"
              @delete="onDelete"
            ></ic-firebase-upload>
            <h3>Social</h3>
            <img :src="editPodcast.obj.socialImage" style="width:100px;height:100px;display:block">
            <ic-firebase-upload
              path="images"
              max-files="1"
              :getFileName="getFileName"
              :storage="storage"
              @uploaded="onUploadedPodcastSocialImage"
              @upload="onUpload"
              @delete="onDelete"
            ></ic-firebase-upload>
          </div>
        </grid-x>
      </div>
      <div class="col-2">
        <h3>New Podcast</h3>
        <div class="widget-buttons">
          <button @click="showNewPodcast = !showNewPodcast">New Podcast</button>
        </div>
        <div v-if="showNewPodcast">
          <div class="input-box">
            <input v-model="newPodcast.key" type="text" placeholder="Podcast Slug">
          </div>
          <div class="input-box">
            <input v-model="newPodcast.obj.title" type="text" placeholder="Podcast Title">
          </div>
          <div class="input-box">
            <input v-model="newPodcast.obj.rss" type="text" placeholder="Podcast RSS">
          </div>
          <div class="input-box">
            <input v-model="newPodcast.obj.seoTitle" type="text" placeholder="SEO Title">
          </div>
          <div class="input-box">
            <input
              v-model="newPodcast.obj.seoDescription"
              type="text"
              placeholder="SEO Description"
            >
          </div>
          <div class="input-box">
            <input v-model="newPodcast.obj.subscribeUrl" type="text" placeholder="Subscribe URL">
          </div>
          <button @click="createPodcast">Create Podcast Entry</button>
        </div>
      </div>
    </grid-x>
    <div v-if="editPodcastMode" class="all-episodes">
      <h3>All Episodes</h3>
      <div class="draggable-items" v-for="(item,key) in podcastEpisodes" :key="key">
        <grid-x col="1fr 200px 1fr" row="1fr" gap="2em">
          <div class="flex center-flex-y">
            <span class="flex-1">{{timestampToDate(item.timestamp)}}</span>
            <span class="flex-3">{{item.title}}</span>
          </div>
          <div class="flex center-flex-x" style="max-height: 75px;">
            <img
              :src="item.overrideImage ? item.overrideImage : item.image"
              style="width:50px;height:100%;"
            >
            <img v-if="item.socialImage" :src="item.socialImage" style="width:50px;height:auto;">
          </div>
          <div class="flex">
            <span class="flex center-flex-y">Square-></span>
            <ic-firebase-upload
              path="images"
              max-files="1"
              :getFileName="getFileName"
              :storage="storage"
              @uploaded="onUploadedEpisodeImage($event,item)"
              @upload="onUpload"
              @delete="onDelete"
            ></ic-firebase-upload>

            <span class="flex center-flex-y">Social-></span>
            <ic-firebase-upload
              path="images"
              max-files="1"
              :getFileName="getFileName"
              :storage="storage"
              @uploaded="onUploadedEpisodeSocialImage($event,item)"
              @upload="onUpload"
              @delete="onDelete"
            ></ic-firebase-upload>

           <!-- <button @click="showModalPodcast(item)" class="flex center-flex-y">Update SEO</button> -->
           <modal-button :passedItem="item" class="flex center-flex-y">Update SEO</modal-button>
           <button @click="updateCacheEpisode(item)" class="flex center-flex-y">Refresh</button>
           <!-- <modal-podcast v-if="showPodModal" :modal.sync="showPodModal" :passedObject="objectToPass"></modal-podcast> -->
          </div>
        </grid-x>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import firebase from "firebase";
import VueFirestore from "vue-firestore";
import ModalButton from "../ModalButton.vue";
require("firebase/firestore");
Vue.use(VueFirestore);
var firestore;

import moment from "moment";
import gridX from "../widgets/gridX";

let Parser = require("rss-parser");
let parser = new Parser();

import IcFirebaseUploader from "ic-firebase-uploader";
import "ic-firebase-uploader/dist/ic-firebase-uploader.min.css";

export default {
  components: { "ic-firebase-upload": IcFirebaseUploader, gridX ,ModalButton},
  data: function() {
    firestore = firebase.firestore();
    return {
      storage: firebase.storage(),
      podcastEpisodes: [],
      editPodcast: {
        key: "",
        obj: {}
      },
      editPodcastMode: false,
      newPodcast: {
        key: "",
        obj: {
          rss: "",
          title: "",
          image: ""
        }
      },
      selectedPodcast: "",
      showNewPodcast: false,
    };
  },
  firestore() {
    return {
      // Collection
      podcasts: firestore.collection("podcasts")
    };
  },
  methods: {
    onUploadedPodcastImage: function(e) {
      console.log(e);
      e.getDownloadURL().then(url => {
        this.editPodcast.obj.overrideImage = url;
        this.$firestore.podcasts.doc(this.editPodcast.key).update({
          overrideImage: url
        });
      });
    },
    onUploadedPodcastSocialImage: function(e) {
      console.log(e);
      e.getDownloadURL().then(url => {
        this.editPodcast.obj.socialImage = url;
        this.$firestore.podcasts.doc(this.editPodcast.key).update({
          socialImage: url
        });
      });
    },
    onUploadedEpisodeImage: function(e, item) {
      console.log(e);
      e.getDownloadURL().then(url => {
        firestore
          .collection("podcastEpisodes")
          .doc(item[".key"])
          .update({
            overrideImage: url
          });
      });
    },
    onUploadedEpisodeSocialImage: function(e, item) {
      console.log(e);
      e.getDownloadURL().then(url => {
        firestore
          .collection("podcastEpisodes")
          .doc(item[".key"])
          .update({
            socialImage: url
          });
      });
    },
    promptFiles: function(key) {
      this.$refs[key].promptFiles();
    },
    onUpload: function(e) {
      e.doUpload();
    },
    onDelete: function(e) {
      e.doDelete();
    },
    getFileName: function(file) {
      return file.name + Math.floor(Math.random() * 1000);
    },
    editPodcastItem: function(item) {
      this.editPodcastMode = true;
      this.editPodcast = { key: item[".key"], obj: item };
      console.log(this.editPodcast);
      this.$binding(
        "podcastEpisodes",
        firestore
          .collection("podcastEpisodes")
          .where("podcast", "==", item[".key"])
          .orderBy("timestamp", "desc")
      );
    },
    rssDurationToSeconds: function(duration) {
      // var splitDuration = duration.split(":");
      // return (parseInt(splitDuration[0]) * 3600) + (parseInt(splitDuration[1]) * 60) + parseInt(splitDuration[2]);
      return (parseInt(duration));
    },
    updateCacheEpisode: function(item) {
        var podcast = this.podcasts.find(x => x['.key'] === item.podcast);
        parser.parseURL(podcast.rss).then(async response => {
          console.log("response", response);

            var playlistItem = response.items.find(x => /[^/]*$/.exec(x.link)[0] === item.slug);
            if(!playlistItem) {
              var deleteItem = confirm("Episode not found, delete?");
              if(deleteItem) {
                console.log("deleting");
                await firestore
                  .collection("podcastEpisodes")
                  .doc(item[".key"])
                  .delete();
              }
            } else {
              await firestore
                .collection("podcastEpisodes")
                .doc(podcast[".key"] + "-" + /[^/]*$/.exec(playlistItem.link)[0])
                .get()
                .then((data) => {
                var dataObj = {
                  podcast: podcast[".key"],
                  title: playlistItem.title,
                  content: playlistItem.content,
                  timestamp: moment(playlistItem.isoDate).format("X"),
                  url: playlistItem.enclosure.url,
                  image: playlistItem.itunes.image,
                  duration: this.rssDurationToSeconds(playlistItem.itunes.duration),
                  slug: /[^/]*$/.exec(playlistItem.link)[0]
                };
                  if (data.exists) {
                    firestore
                      .collection("podcastEpisodes")
                      .doc(
                        podcast[".key"] +
                          "-" +
                          /[^/]*$/.exec(playlistItem.link)[0]
                      )
                      .update(dataObj);
                  } else {
                    firestore
                      .collection("podcastEpisodes")
                      .doc(
                        podcast[".key"] +
                          "-" +
                          /[^/]*$/.exec(playlistItem.link)[0]
                      )
                      .set(dataObj);
                  }
                });
            }

        });
    },
    updateCachePodcast: function() {
      this.podcasts.forEach(podcast => {
        parser.parseURL(podcast.rss).then(async response => {
          console.log(response);
          firestore
            .collection("podcasts")
            .doc(podcast[".key"])
            .update({
              latest: {
                podcast: podcast[".key"],
                title: response.items[0].title,
                content: response.items[0].content,
                timestamp: moment(response.items[0].isoDate).format("X"),
                url: response.items[0].enclosure.url,
                image: response.items[0].itunes.image,
                duration: this.rssDurationToSeconds(response.items[0].itunes.duration),
                slug: /[^/]*$/.exec(response.items[0].link)[0]
              },
              count: response.items.length
            });


          for await (let playlistItem of response.items) {
            var dataObj = {
              podcast: podcast[".key"],
              title: playlistItem.title,
              content: playlistItem.content,
              timestamp: moment(playlistItem.isoDate).format("X"),
              url: playlistItem.enclosure.url,
              image: playlistItem.itunes.image,
              duration: this.rssDurationToSeconds(playlistItem.itunes.duration),
              slug: /[^/]*$/.exec(playlistItem.link)[0]
            };
            console.log("requesting next one");
            var result = await firestore
              .collection("podcastEpisodes")
              .doc(podcast[".key"] + "-" + /[^/]*$/.exec(playlistItem.link)[0])
              .get()
              .then((data) => {
                if (data.exists) {
                  console.log("old");
                  // firestore
                  //   .collection("podcastEpisodes")
                  //   .doc(
                  //     podcast[".key"] +
                  //       "-" +
                  //       /[^/]*$/.exec(playlistItem.link)[0]
                  //   )
                  //   .update(dataObj);
                  return false;
                } else {
                  console.log("new");
                  firestore
                    .collection("podcastEpisodes")
                    .doc(
                      podcast[".key"] +
                        "-" +
                        /[^/]*$/.exec(playlistItem.link)[0]
                    )
                    .set(dataObj);
                  return true;
                }
              });
              console.log(result);
              if(!result) break;
          };
          console.log("done this one");
        });
      });
      console.log("done all");
    },
    timestampToDate: function(timestamp) {
      return moment.unix(timestamp).format("YYYY-MM-DD");
    },
    removePodcastItem: function(item) {
      let message = `Are you sure you would like to remove ${item.title}?`;
      if(window.confirm(message)) {
        this.$firestore.podcasts.doc(item[".key"]).delete();
      };
    },
    createPodcast: function() {
      var errorMessage = "";
      if (!this.newPodcast.key) {
        errorMessage = "Missing key";
      }
      if (!this.newPodcast.obj.rss) {
        errorMessage = "Missing RSS";
      }
      if (!this.newPodcast.obj.title) {
        errorMessage = "Missing Title";
      }
      if (errorMessage) {
        alert(errorMessage);
        return;
      }
      this.$firestore.podcasts
        .doc(this.newPodcast.key)
        .set(this.newPodcast.obj);
      this.newPodcast = {
        key: "",
        obj: {
          rss: "",
          title: ""
        }
      };
    },

    executeEditPodcast: function() {
      var errorMessage = "";
      if (!this.editPodcast.key) {
        errorMessage = "Missing key";
      }
      if (!this.editPodcast.obj.rss) {
        errorMessage = "Missing RSS";
      }
      if (!this.editPodcast.obj.title) {
        errorMessage = "Missing Title";
      }
      if (errorMessage) {
        alert(errorMessage);
        return;
      }
      this.$firestore.podcasts
        .doc(this.editPodcast.key)
        .set(this.editPodcast.obj);
      this.editPodcast = {
        key: "",
        obj: {
          rss: "",
          title: ""
        }
      };
      this.editPodcastMode = false;
    },
    selected: function() {
      this.$refs.podcastSelector.style.setProperty("--inputColor", "aliceblue");
    },
    changeColor: function() {
      this.$refs.podcastSelector.style.setProperty("--inputColor", "black");
    }
  }
};
</script>

<style scoped>
.ic-fb_uploader {
  width: 100px;
  overflow: hidden;
  margin-top: 0;
}

.ic-fb_uploader-files ul li {
  display: none;
}

.draggable-items {
  justify-content: space-between;
}
.draggable-items > span {
  flex: 1;
}

ul {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// podcasts.vue?b1f329e6